import { TablePriceType, TablePriceRow } from "../../components/TablePrice";

export const type: TablePriceType[] = [
  {
    key: "starter",
    title: "Starter",
    dossier: "",
    prixDossier: "349",
    prixMois: "",
  },
  {
    key: "regular",
    title: "Regular",
    dossier: "",
    prixDossier: "519",
    prixMois: "",
  },
  {
    key: "full",
    title: "Full",
    dossier: "",
    prixDossier: "679",
    prixMois: "",
  },
];

export const row: TablePriceRow[] = [
  {
    title: "Licence",
    list: [
      {
        label: "Nombre de tablettes",
        show: true,
        values: {
          starter: "illimité",
          regular: "illimité",
          full: "illimité",
        },
      },
      {
        label: "Nombre d'utilisateurs",
        show: true,
        values: {
          starter: "illimité",
          regular: "illimité",
          full: "illimité",
        },
      },
      {
        label: "Nombre de signatures max./an",
        show: true,
        values: {
          starter: "2500",
          regular: "5000",
          full: "illimité",
        },
      },
      {
        label: "Personnalisation",
        show: true,
        icon: true,
        tooltipText: "Branding et PDF",
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Android et iOS",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Online/Offline",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
    ],
  },
  {
    title: "Fonctionnalités",
    list: [
      {
        label: "Complétion auto. des adresses",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Signatures incomplètes",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Dons one-off et récurrents",
        show: true,
        icon: true,
        tooltipText: "Multi-périodiques",
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Auto-déduction BIC",
        show: true,
        icon: true,
        tooltipText:
          "Disponible en Allemagne, Belgique, Luxembourg, Pays-Bas et Suisse.",
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "IBAN converter",
        show: true,
        icon: true,
        tooltipText: "Uniquement pour les comptes belges.",
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Génération automatique RUM",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Signature manuscrite, photo, ou QR *",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Mode ''Super recruteur''",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Push notification rendez-vous *",
        show: true,
        values: {
          starter: false,
          regular: false,
          full: true,
        },
      },
      {
        label: "Email/SMS de confirmation *",
        show: true,
        icon: true,
        tooltipText: "Les frais d’envoi de SMS ne sont pas compris.",
        values: {
          starter: false,
          regular: false,
          full: true,
        },
      },
      {
        label: "Filtres par utilisateur.",
        show: true,
        icon: true,
        tooltipText: "Filtres teamleader, team ou campagnes par utilisateur.",
        values: {
          starter: false,
          regular: true,
          full: true,
        },
      },
      {
        label: "Émulateur de compte",
        show: true,
        icon: true,
        tooltipText: "Réplication de la session utilisateur en ligne.",
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
    ],
  },
  {
    title: "Données",
    list: [
      {
        label: "Transmission par FTP",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
      {
        label: "Transmission personnalisée",
        show: true,
        values: {
          starter: false,
          regular: "Sur devis",
          full: "Sur devis",
        },
      },
      {
        label: "Anonymisation des données *",
        show: true,
        values: {
          starter: true,
          regular: true,
          full: true,
        },
      },
    ],
  },
  {
    title: "Compléments",
    list: [
      {
        label: "Participations évolution focus group",
        show: true,
        values: {
          starter: false,
          regular: "2",
          full: "4",
        },
      },
      {
        label: "Développement sur-mesure",
        show: true,
        values: {
          starter: false,
          regular: "Sur devis",
          full: "Sur devis",
        },
      },
    ],
  },
  {
    list: [
      {
        label: "Setup",
        show: true,
        values: {
          starter: "2500€",
          regular: "2500€",
          full: "2500€",
        },
      },
    ],
  },
];
